<template>
  <div>
    <h4>{{ $t('major-projects') }}</h4>
    <p>{{ $t('major-projects-definition') }}</p>
    <div v-if="loading" class="text-center">
      <p>{{ $t('loading') }}</p>
    </div>
    <div v-else-if="error" class="alert alert-danger">
      {{ $t('error-loading-data') }}
    </div>
    <div v-else>
      <div v-if="majorProjects.length === 0" class="alert alert-info">
        {{ $t('no-major-projects') }}
      </div>
      <table v-else class="table table-bordered table-striped">
        <thead>
          <tr>
            <th scope="col">{{ $t('address') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(project, index) in majorProjects" :key="index">
            <td style="text-align: left;">{{ project.address }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "MajorProjects",
  data() {
    return {
      majorProjects: [],
      loading: false,
      error: false
    }
  },

  props: {
    curYear: String,
    startDate: String,
    endDate: String,
  },

  created() {
    this.fetchData();
  },

  watch: {
    endDate() {
      this.fetchData();
    }
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.error = false;
      
      try {
        const response = await axios.get(
          `https://data.winnipeg.ca/resource/it4w-cpf4.json`,
          {
            params: {
              $select: 'address',
              $where: `date_trunc_ym(issue_date)='${this.endDate}' and major_project='Yes'`,
              $order: 'street_name,street_number'
            }
          }
        );
        
        this.majorProjects = response.data || [];
      } catch (err) {
        console.error('Error fetching major projects:', err);
        this.error = true;
        this.majorProjects = [];
      } finally {
        this.loading = false;
      }
    },

    formatAddress(project) {
      const parts = [];
      
      if (project.street_number) {
        parts.push(project.street_number);
      }
      
      if (project.street_name) {
        parts.push(project.street_name);
      }
      
      if (project.street_type) {
        parts.push(project.street_type);
      }
      
      return parts.join(' ');
    }
  }
};
</script>
